import lottie from "lottie-web";
import headerLottie from "../../assets/lotties/HSFlogo.json";

import type { AnimationItem } from "lottie-web";
import { isFirefox } from "../utils/variables";

export let headerLotties: AnimationItem[] = [];

export default function initHeaderLogo() {
    const headers = document.querySelectorAll<HTMLElement>(".header");

    headers.forEach(header => {
        const headerLogo = header.querySelector<HTMLElement>(".header__logo");
        if (!headerLogo) return;

        const headerLogoInner = headerLogo.querySelector<HTMLElement>(".header__logo__inner");
        if (!headerLogoInner) return;

        let lottieEl = lottie.loadAnimation({
            container: headerLogoInner,
            animationData: headerLottie,
            renderer: !isFirefox ? "svg" : "canvas",
            loop: false,
            autoplay: false,
        });

        headerLotties.push(lottieEl);
    });
}
